// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1dA7_","sendOtp":"AuthorizeToLogin_sendOtp__38P2s"};